export {default} from "./table"